var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.965,
    viewBox: "0 0 20 19.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M0,16.418V3.551a1.065,1.065,0,0,0,.035-.13A3.916,3.916,0,0,1,3.9.006q6.1-.013,12.2,0a3.909,3.909,0,0,1,3.751,2.866c.059.21.1.427.148.64V16.456a.658.658,0,0,0-.034.109,3.918,3.918,0,0,1-3.008,3.295c-.169.04-.341.07-.512.105H3.555a.971.971,0,0,0-.129-.035A3.929,3.929,0,0,1,.114,16.966C.07,16.784.037,16.6,0,16.417ZM14.85,6.493a3.392,3.392,0,0,0-1.59-2.923,6.194,6.194,0,0,0-3.86-.9,5.127,5.127,0,0,0-2.42.793,3.664,3.664,0,0,0-1.8,2.494,1.2,1.2,0,0,0,.9,1.517A1.308,1.308,0,0,0,7.6,6.859c.181-.3.326-.62.481-.934A1.8,1.8,0,0,1,9.216,4.98a2.34,2.34,0,0,1,1.08-.064,1.6,1.6,0,0,1,1.52,1.468,1.681,1.681,0,0,1-.407,1.322,8.03,8.03,0,0,1-.786.754c-.509.444-1.047.858-1.541,1.318a2.141,2.141,0,0,0-.72,1.761,1.2,1.2,0,0,0,1.009,1.211c.849.106,1.27-.177,1.493-.8.026-.073.055-.145.083-.218a2.637,2.637,0,0,1,.9-1.174c.706-.541,1.411-1.09,2.064-1.693a3.035,3.035,0,0,0,.944-2.369ZM8.084,15.72a1.611,1.611,0,0,0,1.6,1.618,1.625,1.625,0,1,0-1.6-1.618Z",
    transform: "translate(0 0)",
    fill: "#9180eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.0e1b3a1bb122331b45b33a5b8d4888a0.svg";
export { ForwardRef as ReactComponent };